import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import LS from '../styles/layoutStyled'
import CS from '../styles/componentStyled'
import AlarmModal3 from '../modal/AlarmModal3';
import CertificateModal from '../modal/CertificateModal';
import { ApiService } from '../api';
import { locationsData } from '../component/locationData';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { accessTokenState, refreshTokenState, expireState } from '../atom/TokenAtom';
import { alarmModal1Text } from '../atom/ModalAtom';
import { Config } from '../config';
import CertificateExcelModal from '../modal/CertificateExcelModal';
import Pagenation from '../component/Pagenation';

const Certification = () => {
    const apiService = new ApiService();
    const navigate = useNavigate();
    const setAlarm1Text = useSetRecoilState(alarmModal1Text);

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [listLength, setListLength] = useState<number>(0);
    const [resetTrigger, setResetTrigger] = useState(false);

    // 토큰
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [expire, setExpire] = useRecoilState(expireState);

    // 인증서 모달
    const [isCertificateModal, setIsCertificateModal] = useState(false);
    const closeCertificateModal = () => {
        setIsCertificateModal(false);
    }

    // 인증서 모달 props
    const [mode, setMode] = useState('');

    // 인증서 수정 객체
    const [modifyItem, setModifyItem] = useState('');

    // oo개씩 보기
    const handleViewNumChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setLimit(parseInt(e.target.value));
        setCheckItems([]);
        setOffset(0);
    }

    const [certificates, setCertificates] = useState<any[]>([]);

    // 인증서 목록
    const fetchCertificationList: any = async (searchOffset?: number) => {
        if (searchOffset !== undefined) {
            setOffset(searchOffset);
        }
        try {
            if (!accessToken) return;
            const certificationList = await apiService.getCertificationList(accessToken, facilityNumber, applicant, sido, sigungu, location, phoneNumber, offset, limit);
            setCertificates(certificationList);
        }
        catch(err: any) {
            localStorage.clear();
            navigate('/login');
        }
    };

    const fetchCertificationAllList: any = async (searchOffset?: number) => {
        if (searchOffset !== undefined) {
            setOffset(searchOffset);
        }
        try {
            if (!accessToken) return;
            const certificationList = await apiService.getCertificationList(accessToken, facilityNumber, applicant, sido, sigungu, location, phoneNumber);
            setListLength(certificationList.length);
        }
        catch(err: any) {
            localStorage.clear();
            navigate('/login');
        }
    };

    useEffect(() => {
        fetchCertificationList();
        fetchCertificationAllList();
    }, [offset, limit, resetTrigger]);

    // 시설물 번호
    const [facilityNumber, setFacilityNumber] = useState('');
    const handleFacilityNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFacilityNumber(value);
    };

    // 신청자
    const [applicant, setApplicant] = useState('');
    const handleApplicantChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setApplicant(value);
    };

    // 휴대폰 번호
    const [phoneNumber, setPhoneNumber] = useState('');
    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPhoneNumber(value);
    };

    // 시/도
    const sidoRef = useRef<HTMLSelectElement>(null);
    const [sido, setSido] = useState<string>('');
    const handleSidoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;
        setSido(selectedValue);
        sidoRef.current?.classList.add("selected");
        if (selectedValue === '') {
            sidoRef.current?.classList.remove("selected");
        }
        setSigungu('');
        sigunguRef.current?.classList.remove("selected");
    };

    // 시군구
    const sigunguRef = useRef<HTMLSelectElement>(null);
    const [sigungu, setSigungu] = useState<string>('');
    const handleSigunguChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSigungu(e.target.value);
        sigunguRef.current?.classList.add("selected");
        if (e.target.value === '') {
            sigunguRef.current?.classList.remove("selected");
        }
    };

    // 주소
    const [location, setLocation] = useState('');
    const handlelocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLocation(value);
    };

    const handleSearchReset = () => {
        setOffset(0);
        setLimit(10);
        setFacilityNumber('');
        setPhoneNumber('');
        setApplicant('');
        setSido('');
        setSigungu('');
        setLocation('');
        sidoRef.current?.classList.remove("selected");
        sigunguRef.current?.classList.remove("selected");
        setResetTrigger(!resetTrigger);
    }

    // 아이템 선택
    const [checkItems, setCheckItems] = useState<number[]>([]);
    const handleSingleCheck = (checked: boolean, id: number) => {
        if (checked) {
            setCheckItems(prev => [...prev, id]);
        }
        else {
            setCheckItems(prev => prev.filter((el) => el !== id));
        }
    }
    const handleAllCheck = (checked: boolean) => {
        if (checked) {
            const idArray: number[] = [];
            certificates.forEach((el) => idArray.push(el.id));
            setCheckItems(idArray);
        }
        else {
            setCheckItems([]);
        }
    }

    // 선택 삭제 버튼 클릭시
    const [isDelConfirmModal, setIsDelConfirmModal] = useState(false);
    const openDelConfirmModal = () => {
        if (checkItems.length === 0) {
            setAlarm1Text("선택된 항목이 없습니다.");
            return;
        }
        setIsDelConfirmModal(true);
    }
    const closeDelConfirmModal = () => {
        setIsDelConfirmModal(false);
    }
    const handleConfirm: any = async () => {
        if (!accessToken) return;
        await apiService.delCertification(accessToken, checkItems);
        window.location.reload();
    }

    // pdf 보기
    const handlePdfView = (pdfUrl: string) => {
        window.open(`${Config.API_URL}/console/structure/certification/pdf/view/${pdfUrl}`, '_blank');
    }

    // 엑셀 등록
    const [isCertificateExcelModal, setIsCertificateExcelModal] = useState(false);
    const closeCertificateExcelModal = () => {
        setIsCertificateExcelModal(false);
    }

    const handleOffsetChange = (value: number) => {
        setOffset((value - 1) * limit);
        setCheckItems([]);
    }

    return (
        <>
            <h1>건축물 안전 인증서</h1>

            <CS.SearchOptionBox>
                <div className="search-area">
                    <ul>
                        <li>
                            <h3>시설물 번호</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="시설물 번호"
                                    value={facilityNumber}
                                    onChange={handleFacilityNumberChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>신청자</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="신청자"
                                    value={applicant}
                                    onChange={handleApplicantChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>휴대폰 번호</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="휴대폰 번호(-자 제외)"
                                    value={phoneNumber}
                                    onChange={handlePhoneNumberChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>소재지</h3>
                            <div className="input-area">
                                <CS.SelectType1>
                                    <select
                                        value={sido}
                                        onChange={handleSidoChange}
                                        ref={sidoRef}
                                    >
                                        <option value="" style={{ color: '#999' }}>시/도</option>
                                        {locationsData.map((sido, index) => (
                                            <option key={index} value={sido.name}>{sido.name}</option>
                                        ))}
                                    </select>
                                    <span className='img-box'>
                                        <img src="./img/arrow_bottom_898989.svg" alt="" />
                                    </span>
                                </CS.SelectType1>
                                <CS.SelectType1>
                                    <select
                                        value={sigungu}
                                        onChange={handleSigunguChange}
                                        ref={sigunguRef}
                                    >
                                        <option value="" style={{ color: '#999' }}>시군구</option>
                                        {sido &&
                                            locationsData.find(item => item.name === sido)?.subArea.map((sigungu, index) => (
                                            <option key={index} value={sigungu}>{sigungu}</option>
                                        ))}
                                    </select>
                                    <span className='img-box'>
                                        <img src="./img/arrow_bottom_898989.svg" alt="" />
                                    </span>
                                </CS.SelectType1>
                            </div>
                        </li>
                        <li>
                            <h3>주소</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="주소"
                                    value={location}
                                    onChange={handlelocationChange}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="btn-box flex aic jcc">
                    <CS.Btn3Type1 onClick={() => {
                        fetchCertificationList(0);
                        fetchCertificationAllList(0);
                    }}>검색</CS.Btn3Type1>
                    <CS.Btn3Type2 onClick={handleSearchReset}>초기화</CS.Btn3Type2>
                </div>
            </CS.SearchOptionBox>

            <CS.TableOptionBox>
                <div className="all-text-box">
                    전체 <span>{certificates.length}</span>개
                </div>
                <div className="btn-option-box">
                    <CS.SelectType1 style={{ width: 130 }}>
                        <select
                            value={limit}
                            onChange={handleViewNumChange}
                            className='selected'
                        >
                            <option value={10}>10개씩 보기</option>
                            <option value={20}>20개씩 보기</option>
                            <option value={30}>30개씩 보기</option>
                            <option value={50}>50개씩 보기</option>
                        </select>
                        <span className='img-box'>
                            <img src="./img/arrow_bottom_898989.svg" alt="" />
                        </span>
                    </CS.SelectType1>
                    <CS.Btn3Type3 onClick={openDelConfirmModal}>선택 삭제</CS.Btn3Type3>
                    <CS.Btn3Type4 onClick={() => setIsCertificateExcelModal(true)}>Excel 등록</CS.Btn3Type4>
                    <CS.Btn3Type2 
                        onClick={() => {
                            setIsCertificateModal(true);
                            setMode('add');
                            setModifyItem('');
                        }}
                    >등록</CS.Btn3Type2>
                </div>
            </CS.TableOptionBox>

            <CS.TableType1>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <CS.CheckBoxType1>
                                    <input
                                        type="checkbox"
                                        id="all"
                                        onChange={(e) => handleAllCheck(e.target.checked)}
                                        checked={
                                            certificates.length === 0
                                            ? false : checkItems.length === (certificates.length < limit ? certificates.length : limit) ? true : false
                                        }
                                    />
                                    <label htmlFor="all"></label>
                                </CS.CheckBoxType1>
                            </th>
                            <th>No</th>
                            <th>시설물번호</th>
                            <th>신청자</th>
                            <th>휴대폰 번호</th>
                            <th>소재지</th>
                            <th>발급일자</th>
                            <th>유효기간</th>
                            <th>상태</th>
                            <th>증명서</th>
                        </tr>
                    </thead>
                    <tbody>
                        {certificates.map((certificate, index) => (
                            <tr key={index}>
                                <td>
                                    <CS.CheckBoxType1>
                                        <input
                                            type="checkbox"
                                            id={`cv-${index}`}
                                            onChange={(e) => handleSingleCheck(e.target.checked, certificate.id)}
                                            checked={checkItems.includes(certificate.id) ? true : false}
                                        />
                                        <label htmlFor={`cv-${index}`}></label>
                                    </CS.CheckBoxType1>
                                </td>
                                <td>{(offset + index + 1).toLocaleString()}</td>
                                <td>
                                    <button
                                        className='modify-btn'
                                        onClick={() => {
                                            setIsCertificateModal(true);
                                            setMode('');
                                            setModifyItem(certificate);
                                        }}
                                    >
                                        {certificate.structure_num}
                                    </button>
                                </td>
                                <td>{certificate.applicant}</td>
                                <td>{certificate.phone_number}</td>
                                <td>{certificate.address.replace("?", " ")}</td>
                                <td>{new Date(certificate.created_at).toLocaleDateString()}</td>
                                <td>{new Date(certificate.exp_date).toLocaleDateString()}</td>
                                {new Date(certificate.exp_date) < new Date() && (
                                    <td className='expiration'>만료</td>
                                )}
                                {new Date(certificate.exp_date) >= new Date() && (
                                    <td className='normal'>정상</td>
                                )}
                                <td>
                                    <button className='pdf-btn img-box' onClick={() => handlePdfView(certificate.pdf_uuid)}>
                                        <img src="./img/ico_pdf.svg" alt="" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </CS.TableType1>

            {listLength !== 0 &&
                <Pagenation
                    listAllLength={listLength}
                    listLimit={limit}
                    onCurrentPageChange={handleOffsetChange}
                />
            }

            {isCertificateModal && (
                <CertificateModal
                    mode={mode}
                    onClose={closeCertificateModal}
                    modifyItem={modifyItem}
                />
            )}

            {isCertificateExcelModal && (
                <CertificateExcelModal
                    onClose={closeCertificateExcelModal}
                />
            )}

            {isDelConfirmModal && (
                <AlarmModal3
                    modalType='del'
                    onClose={closeDelConfirmModal}
                    onConfirm={handleConfirm}
                />
            )}
        </>
    );

};

export default Certification;
